export default __webpack_public_path__ + "static/banner-1ca93ac27ac5cd0e431f98231bc8a31d.png";